<template>
  <v-container fluid>
    <base-material-card id="validador-data-table-bmc" color="primary" icon="mdi-clipboard-check" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div id="title-validador" class="display-2 font-weight-light">Validador Contábil</div>
      </template>
      <v-btn
        id="btn-nova-validacao"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push('edit')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Nova validação
      </v-btn>
      <v-text-field
        id="validacoes-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <general-progress-bars class="mt-11" :items="downloadProgressData" prefix-text="Baixando Validação" />
      <v-divider class="mt-10" />
      <v-data-table
        class="validacoes-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :header-props="{
          sortByText: 'Ordenar Por'
        }"
        :footer-props="{
          itemsPerPageText: 'Itens por Página'
        }"
        no-data-text="Nenhuma validação disponível"
        no-results-text="Nenhum registro correspondente encontrado"
        mobile-breakpoint="800"
        :loading="loading"
      >
        <template v-slot:[`item.id`]="{ item }">
          {{ item.id }}
        </template>
        <template v-slot:[`item.nome`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                class="text-truncate-column"
                :class="['EXECUTANDO', 'AGUARDANDO'].includes(item.status) ? 'clickable-item' : ''"
                v-on="on"
                @click="openModalAcompanhamento(item)"
              >
                {{ item.nome }}
              </div>
            </template>
            <span>{{ item.nome }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.usuario`]="{ item }">
          {{ item.usuario }}
        </template>
        <template v-slot:[`item.data_execucao`]="{ item }">
          {{ item.data_execucao }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            id="action-download-validacao"
            :class="item.status != 'SUCESSO' ? 'cursor-block' : ''"
            :disabled="item.status != 'SUCESSO'"
            min-width="0"
            class="px-1"
            fab
            icon
            x-small
            :loading="downloadProgressData[item.id] !== undefined ? true : false"
            @click="downloadItem(item)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-btn
            id="action-edit-validacao"
            :class="!canEditItem(item) ? 'cursor-block' : ''"
            :disabled="!canEditItem(item)"
            min-width="0"
            class="ml-n1 px-1"
            fab
            icon
            x-small
            @click="$router.push(`edit/${item.id}`)"
          >
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more-validacao"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canRunItem(item)" @click="executarValidacao(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item.id, item.nome)">
                <v-list-item-title>
                  <v-icon small>mdi-trash-can-outline</v-icon>
                  Deletar
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogDetalhes(item)">
                <v-list-item-title>
                  <v-icon small>mdi-file-find-outline</v-icon>
                  Detalhes
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer`]>
          <v-switch
            v-if="$store.getters.userIsAdmin"
            class="pa-0 pl-2 swithInterna"
            style="position: absolute"
            color="primary"
            label="Exibir Expirados"
            dense
            @change="$emit('switchProcessamentosExpirados', $event)"
          />
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-delete
      :show-dialog="dialogDelete"
      @changeValue="dialogDelete = $event"
      @deleteTriggered="excluirValidacao(dialogDeleteData.id)"
    >
      <template slot="title">Deletar Validação #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar a validação
        <strong>{{ dialogDeleteData.nome }}</strong>
        ?
      </template>
    </dialog-delete>
    <general-dialog-detalhes
      ref="dialogDetalhes"
      title="Detalhes da Validação"
      :show-dialog="dialogDetalhes"
      @changeValue="dialogDetalhes = $event"
    >
      <template slot="body">
        <v-data-table
          :headers="dialogDetalhesHeader"
          :items="dialogDetalhesData"
          hide-default-footer
          class="elevation-1 style-table-dialog-detalhes"
          disable-pagination
          mobile-breakpoint="10"
        >
          <template v-slot:item="row">
            <tr>
              <td class="button" width="210px">
                {{ row.item.parametro }}
              </td>
              <td v-if="row.item.parametro.indexOf('obra') == -1" class="button">
                {{ row.item.valor }}
              </td>
              <td v-else-if="row.item.valor.length == 0" class="button" />
              <td v-else-if="row.item.valor.length == 1" class="button">
                {{ row.item.valor[0] }}
              </td>
              <td v-else class="button" style="padding-left: 0px !important">
                <v-textarea
                  rows="5"
                  no-resize
                  readonly
                  class="ml-4 mt-0 pt-0"
                  :value="$refs.dialogDetalhes.updateValueTextArea(row.item.valor)"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </general-dialog-detalhes>
    <general-dialog-acompanhamento
      ref="dialogAcompanhamento"
      :show-dialog="dialogAcompanhamento"
      :messages="dialogAcompanhamentoData.andamento"
      :name-event-pusher="'andamento-validacao-contabil-' + dialogAcompanhamentoData.id"
      @changeValue="dialogAcompanhamento = $event"
    >
      <template slot="title">Andamento da Validação #{{ dialogAcompanhamentoData.id }}</template>
    </general-dialog-acompanhamento>
  </v-container>
</template>

<script>
  import ValidadorContabilService from '@/services/ValidadorContabilService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';

  export default {
    components: {
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralDialogAcompanhamento: () => import('@/components/general/GeneralDialogAcompanhamento'),
      GeneralProgressBars: () => import('@/components/general/GeneralProgressBars.vue'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      GeneralDialogDetalhes: () => import('@/components/general/GeneralDialogDetalhes')
    },
    mixins: [powerupsActionsMixins],

    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    emits: ['switchProcessamentosExpirados', 'recharge'],

    data() {
      return {
        powerupService: ValidadorContabilService,
        powerupEntityName: 'Validacao Contabil',
        dialogDelete: false,
        dialogDeleteData: { id: undefined, nome: undefined },
        dialogDetalhes: false,
        dialogDetalhesData: [],
        dialogDetalhesHeader: [
          { text: 'Resumo', value: 'parametro', sortable: false },
          { text: '', value: 'valor', sortable: false }
        ],
        dialogAcompanhamento: false,
        dialogAcompanhamentoData: { id: undefined, andamento: [] },
        search: '',
        headers: [
          {
            text: '#',
            value: 'id'
          },
          {
            text: 'Nome',
            value: 'nome'
          },
          {
            text: 'Usuário',
            value: 'usuario'
          },
          {
            text: 'Executado',
            value: 'data_execucao'
          },
          {
            text: 'Status',
            value: 'status'
          },
          {
            sortable: false,
            text: 'Ações',
            value: 'actions',
            class: 'pl-4'
          }
        ],
        downloadProgressData: {}
      };
    },

    computed: {
      user() {
        return this.$store.getters.getUser;
      }
    },

    methods: {
      executarValidacao(id) {
        ValidadorContabilService.executar(id, this.user.uid)
          .then(() => {
            this.$toast.success('Sua planilha será gerada em instantes. Por favor, aguarde.', '', { position: 'topRight' });
            this.$emit('recharge');
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao executar validação.', '', { position: 'topRight' });
          });
      },

      excluirValidacao(id) {
        ValidadorContabilService.deletar(id, this.user.uid)
          .then(() => {
            this.$toast.success('Validação excluida com sucesso.', '', { position: 'topRight' });
            this.$emit('recharge');
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao excluir validação.', '', { position: 'topRight' });
          });

        this.dialogDelete = false;
      },

      openDialogDelete(id, nome) {
        this.dialogDeleteData = { id: id, nome: nome };
        this.dialogDelete = true;
      },

      openDialogDetalhes(validacao) {
        const detalhes = [];

        detalhes.push({
          parametro: 'Nome:',
          valor: validacao.nome
        });

        if (validacao.testes) {
          const testesAtivos = Object.entries(validacao.testes)
            .filter(([, ativo]) => ativo)
            .map(([nome]) => {
              const labels = {
                ros: 'ROS',
                roa: 'ROA',
                razaoAis: 'Razão x AIS',
                ais: 'AIS'
              };
              return labels[nome] || nome;
            });

          if (testesAtivos.length) {
            detalhes.push({
              parametro: testesAtivos.length > 1 ? 'Testes:' : 'Teste:',
              valor: testesAtivos.join(', ')
            });
          }
        }

        if (validacao.data_imobilizacao_inicial && validacao.data_imobilizacao_inicial !== '-') {
          detalhes.push({
            parametro: 'Data da imobilização inicial:',
            valor: validacao.data_imobilizacao_inicial
          });
        }

        if (validacao.data_imobilizacao_final && validacao.data_imobilizacao_final !== '-') {
          detalhes.push({
            parametro: 'Data da imobilização final:',
            valor: validacao.data_imobilizacao_final
          });
        }

        if (validacao.ais_database && validacao.ais_database !== '-') {
          detalhes.push({
            parametro: 'Database AIS:',
            valor: validacao.ais_database
          });
        }

        this.dialogDetalhesData = detalhes;
        this.dialogDetalhes = true;
      },

      openModalAcompanhamento(validacao) {
        if (!['EXECUTANDO', 'AGUARDANDO'].includes(validacao.status)) {
          return;
        }
        this.dialogAcompanhamentoData.id = validacao.id;
        this.dialogAcompanhamento = true;

        this.attAndamentoValidacao(validacao.id);
      },

      attAndamentoValidacao(id) {
        ValidadorContabilService.andamento(id)
          .then((response) => {
            this.dialogAcompanhamentoData.andamento = response.data.data;
            this.$refs.dialogAcompanhamento.activatePusher();
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar andamento da validação.', '', { position: 'topRight' });
          });
      }
    }
  };
</script>

<style>
  @media screen and (min-width: 800px) {
    .validacoes-table table tr td:nth-child(2) {
      max-width: 200px;
    }

    .validacoes-table table tr td:nth-child(5),
    .validacoes-table table tr td:nth-child(6) {
      white-space: nowrap !important;
    }
  }

  @media screen and (max-width: 500px) {
    #title-validador {
      font-size: 1.4em !important;
    }
  }

  #validador-data-table-bmc .mdi-set-merge {
    font-size: 40px !important;
  }

  #validador-data-table-bmc .v-card--material__heading {
    padding: 12px !important;
  }

  .swithInterna label {
    font-size: 13px !important;
    margin-left: 0px !important;
  }
</style>
